exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#socialmedia .div-header{\n  background-color: #fcfcfc;\n  padding-bottom: 15px;\n  padding-top: 12px;\n}\n\n#socialmedia .span_socialmedia{\n    color: #9b9b9b;\n}\n\n#socialmedia md-dialog-container{\n  border: 1px solid #dadada !important;;\n  padding: 20px !important;\n  overflow: hidden !important;\n  border-radius: 4px !important;\n  margin-top:40px !important;\n}\n\n#socialmedia md-dialog-content {\n  margin-top: -10px !important;\n}\n\n#socialmedia{\n  width: 500px;\n  min-height:300px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/socialmedia-dialog/socialmedia-dialog.component.css
// module id = ../../../../../src/app/pages/socialmedia-dialog/socialmedia-dialog.component.css
// module chunks = main